if (!customElements.get('recipe-products')) {
  class RecipeProducts extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-recipe-products-message]');
      this.addAllButton = this.querySelector('[data-recipe-add-all]');
      this.addAllButton?.addEventListener('click', () => this.onAddAll());
      this.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-recipe-add-single]');
        if (addButton) {
          event.preventDefault();
          this.onAddSingle(addButton);
        }
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-recipe-variant-select]')) {
          this.onVariantChange(event.target);
        }
      });
      this.bindScrollRevealRefresh();
      this.scheduleSliderInit();
    }

    bindScrollRevealRefresh() {
      if (!this.classList.contains('scroll-trigger')) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        window.setTimeout(() => this.refreshSlider(), 0);
        window.setTimeout(() => this.refreshSlider(), 150);
        window.setTimeout(() => this.refreshSlider(), 400);
      });

      observer.observe(this);
    }

    scheduleSliderInit() {
      const attempt = () => this.initSlider();

      if (attempt()) return;

      let tries = 0;
      const timer = window.setInterval(() => {
        if (attempt() || ++tries >= 40) {
          window.clearInterval(timer);
        }
      }, 100);

      window.addEventListener(
        'load',
        () => {
          attempt();
          this.refreshSlider();
        },
        { once: true }
      );
    }

    buildSlickOptions(slideCount) {
      const cap = (count) => Math.min(count, slideCount);

      const desktop = cap(4);
      const tablet = cap(3);
      const mobile = cap(2);
      const narrow = cap(1);

      return {
        slidesToShow: desktop,
        slidesToScroll: 1,
        infinite: slideCount > desktop,
        dots: false,
        focusOnSelect: slideCount > 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: tablet,
              slidesToScroll: Math.min(3, tablet),
              infinite: slideCount > tablet,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: mobile,
              slidesToScroll: Math.min(2, mobile),
              infinite: slideCount > mobile,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: narrow,
              slidesToScroll: 1,
              infinite: slideCount > narrow,
            },
          },
        ],
      };
    }

    initSlider() {
      const grid = this.querySelector('.product-grid');
      if (!grid || typeof jQuery === 'undefined' || !jQuery.fn?.slick) return false;

      const $grid = jQuery(grid);
      if ($grid.hasClass('slick-initialized')) {
        this.refreshSlider();
        return true;
      }

      const slideCount = $grid.children().length;
      if (slideCount < 1) return false;

      $grid
        .off('init.recipeProducts')
        .on('init.recipeProducts', () => {
          window.setTimeout(() => this.refreshSlider(), 0);
          window.setTimeout(() => this.refreshSlider(), 120);
        });

      $grid.slick(this.buildSlickOptions(slideCount));
      return true;
    }

    refreshSlider() {
      const grid = this.querySelector('.product-grid');
      if (!grid || typeof jQuery === 'undefined' || !jQuery.fn?.slick) return;

      const $grid = jQuery(grid);
      if (!$grid.hasClass('slick-initialized')) return;

      $grid.slick('setPosition');
      jQuery(window).trigger('resize');
    }

    get cards() {
      const grid = this.querySelector('.product-grid');
      if (!grid) return [];

      if (grid.classList.contains('slick-initialized')) {
        return Array.from(
          grid.querySelectorAll('.slick-slide:not(.slick-cloned)[data-recipe-product-card]')
        );
      }

      return Array.from(grid.querySelectorAll(':scope > [data-recipe-product-card]'));
    }

    getCardRoot(card) {
      return card.querySelector('[data-recipe-product-card-inner]') || card;
    }

    getSelectedVariantId(card) {
      const root = this.getCardRoot(card);
      const select = root.querySelector('[data-recipe-variant-select]');
      if (select?.value) {
        const option = select.selectedOptions[0];
        if (option?.dataset.available === 'false') return null;
        return select.value;
      }

      const input = root.querySelector('[data-recipe-variant-input]:not([disabled]), .product-variant-id:not([disabled])');
      return input?.value || null;
    }

    formatMoney(cents) {
      if (typeof theme !== 'undefined' && theme.Currency?.formatMoney && theme.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }

      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return (cents / 100).toFixed(2);
    }

    onVariantChange(select) {
      const card = select.closest('[data-recipe-product-card]');
      if (!card) return;

      const root = this.getCardRoot(card);
      const option = select.selectedOptions[0];
      if (!option) return;

      const isAvailable = option.dataset.available === 'true';
      const price = Number(option.dataset.price || 0);
      const compareAtPrice = Number(option.dataset.compareAtPrice || 0);
      const isOnSale = compareAtPrice > price;

      const priceEl = root.querySelector('[data-recipe-price]');
      const regularWrap = root.querySelector('[data-recipe-price] .price__regular');
      const saleWrap = root.querySelector('[data-recipe-price] .price__sale');
      const regularEl = root.querySelector('[data-recipe-price-regular]');
      const compareEl = root.querySelector('[data-recipe-price-compare]');
      const saleEl = root.querySelector('[data-recipe-price-sale]');
      const addButton = root.querySelector('[data-recipe-add-single]');
      const wishlistPlaceholder = root.querySelector('.gw-add-to-wishlist-product-card-placeholder');

      if (priceEl) {
        priceEl.classList.toggle('price--sold-out', !isAvailable);
        priceEl.classList.toggle('price--on-sale', isOnSale);
      }

      if (regularWrap) regularWrap.hidden = isOnSale;
      if (saleWrap) saleWrap.hidden = !isOnSale;
      if (regularEl) regularEl.textContent = this.formatMoney(price);
      if (compareEl) compareEl.textContent = this.formatMoney(compareAtPrice);
      if (saleEl) saleEl.textContent = this.formatMoney(price);

      if (addButton) addButton.hidden = !isAvailable;

      if (wishlistPlaceholder) {
        wishlistPlaceholder.dataset.gwVariantId = select.value;
      }
    }

    setButtonLoading(button, isLoading) {
      if (!button) return;
      button.classList.toggle('loading', isLoading);
      button.disabled = isLoading;
    }

    showMessage(text, type = 'success') {
      if (!this.messageEl || !text) return;

      this.messageEl.textContent = text;
      this.messageEl.classList.remove(
        'recipe-products__message--success',
        'recipe-products__message--warning'
      );
      this.messageEl.classList.add(
        type === 'warning' ? 'recipe-products__message--warning' : 'recipe-products__message--success'
      );
      this.messageEl.removeAttribute('hidden');

      window.requestAnimationFrame(() => {
        this.messageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    hideMessage() {
      if (!this.messageEl) return;
      this.messageEl.textContent = '';
      this.messageEl.setAttribute('hidden', '');
      this.messageEl.classList.remove(
        'recipe-products__message--success',
        'recipe-products__message--warning'
      );
    }

    async addVariantToCart(variantId) {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      const data = await response.json();

      if (data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      return data;
    }

    async refreshCartIcon() {
      if (!window.routes?.cart_url) return null;

      const response = await fetch(`${window.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return null;

      const cart = await response.json();

      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
      });

      document.querySelectorAll('[data-cart-count-bubble]').forEach((element) => {
        element.classList.toggle('hide', cart.item_count === 0);
      });

      return cart;
    }

    publishCartUpdate(cartData) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'recipe-products',
          cartData,
        });
      }
    }

    async onAddSingle(button) {
      const card = button.closest('[data-recipe-product-card]');
      if (!card) return;

      this.hideMessage();
      this.setButtonLoading(button, true);

      try {
        const variantId = this.getSelectedVariantId(card);
        if (!variantId) {
          this.showMessage(
            this.buildPartialMessage(0, [card.dataset.productTitle || '']),
            'warning'
          );
          return;
        }

        await this.addVariantToCart(variantId);
        this.showMessage(this.buildSuccessMessage(1), 'success');

        try {
          const cart = await this.refreshCartIcon();
          this.publishCartUpdate(cart);
        } catch (error) {
          console.error(error);
        }
      } catch (error) {
        this.showMessage(
          this.buildPartialMessage(0, [card.dataset.productTitle || '']),
          'warning'
        );
      } finally {
        this.setButtonLoading(button, false);
        const root = this.getCardRoot(card);
        const select = root.querySelector('[data-recipe-variant-select]');
        if (select) this.onVariantChange(select);
      }
    }

    async onAddAll() {
      this.hideMessage();
      this.setButtonLoading(this.addAllButton, true);

      let addedCount = 0;
      const failedTitles = [];

      try {
        for (const card of this.cards) {
          const variantId = this.getSelectedVariantId(card);
          if (!variantId) {
            const title = card.dataset.productTitle || '';
            if (title) failedTitles.push(title);
            continue;
          }

          try {
            await this.addVariantToCart(variantId);
            addedCount += 1;
          } catch (error) {
            const title = card.dataset.productTitle || '';
            if (title) failedTitles.push(title);
          }
        }

        let messageText = null;
        let messageType = 'success';

        if (addedCount === 0 && failedTitles.length > 0) {
          messageText = this.buildPartialMessage(0, failedTitles);
          messageType = 'warning';
        } else if (failedTitles.length > 0) {
          messageText = this.buildPartialMessage(addedCount, failedTitles);
          messageType = 'warning';
        } else if (addedCount > 0) {
          messageText = this.buildSuccessMessage(addedCount);
          messageType = 'success';
        }

        if (messageText) {
          this.showMessage(messageText, messageType);
        }

        if (addedCount > 0) {
          try {
            const cart = await this.refreshCartIcon();
            this.publishCartUpdate(cart);
          } catch (error) {
            console.error(error);
          }
        }
      } finally {
        this.setButtonLoading(this.addAllButton, false);
      }
    }

    buildSuccessMessage(count) {
      const template =
        this.dataset.messageAllAdded || '[count] items added to your cart.';
      return template.replace('[count]', count);
    }

    buildPartialMessage(count, failedTitles) {
      const template =
        this.dataset.messagePartialAdded ||
        '[count] items added to your cart. The following could not be added (out of stock):';
      const listTemplate = this.dataset.messageFailedList || '• [product]';
      const uniqueTitles = [...new Set(failedTitles)];
      const list = uniqueTitles
        .map((title) => listTemplate.replace('[product]', title))
        .join('\n');
      return `${template.replace('[count]', count)}\n${list}`;
    }
  }

  customElements.define('recipe-products', RecipeProducts);

  window.initRecipeProductSliders = function initRecipeProductSliders(root = document) {
    root.querySelectorAll('recipe-products').forEach((element) => {
      if (typeof element.initSlider === 'function') {
        element.initSlider();
        element.refreshSlider();
      }
    });
  };
}
